import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div style={{
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            lineHeight: 1.6,
            color: '#333',
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: '#f8f9fa'
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '40px',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
                <div style={{
                    textAlign: 'center',
                    marginBottom: '30px',
                    padding: '20px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '5px'
                }}>
                    <h1 style={{
                        color: '#2c3e50',
                        textAlign: 'center',
                        borderBottom: '3px solid #3498db',
                        paddingBottom: '10px',
                        marginBottom: '30px'
                    }}>WeLearn</h1>
                    <p><strong>Privacy Policy</strong></p>
                    <p>Package Name: com.welearn4u.app.v2</p>
                    <p>Version: 1.0.4+6</p>
                </div>

                <div style={{
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffeaa7',
                    padding: '15px',
                    borderRadius: '5px',
                    margin: '20px 0'
                }}>
                    <strong>Important:</strong> This Privacy Policy explains how WeLearn collects, uses, and protects your information when you use our educational mobile application. By using our app, you agree to the collection and use of information in accordance with this policy.
                </div>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>1. Information We Collect</h2>

                <h3 style={{
                    color: '#2c3e50',
                    marginTop: '20px',
                    marginBottom: '10px'
                }}>1.1 Personal Information</h3>
                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>We may collect the following personal information:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Account Information:</strong> Name, email address, phone number, school ID, and profile information</li>
                    <li style={{ marginBottom: '8px' }}><strong>Authentication Data:</strong> Login credentials and authentication tokens</li>
                    <li style={{ marginBottom: '8px' }}><strong>Google Account Information:</strong> When you sign in with Google, we may access your basic profile information (name, email, profile picture)</li>
                    <li style={{ marginBottom: '8px' }}><strong>Educational Data:</strong> Study progress, quiz results, learning preferences, and academic performance</li>
                </ul>

                <h3 style={{
                    color: '#2c3e50',
                    marginTop: '20px',
                    marginBottom: '10px'
                }}>1.2 Device and Usage Information</h3>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Device Information:</strong> Device model, operating system version, unique device identifiers</li>
                    <li style={{ marginBottom: '8px' }}><strong>Usage Analytics:</strong> App usage patterns, feature interactions, and performance data</li>
                    <li style={{ marginBottom: '8px' }}><strong>Network Information:</strong> IP address, network type, and connectivity status</li>
                    <li style={{ marginBottom: '8px' }}><strong>Media Files:</strong> Photos and videos uploaded through the app for educational purposes</li>
                </ul>

                <h3 style={{
                    color: '#2c3e50',
                    marginTop: '20px',
                    marginBottom: '10px'
                }}>1.3 Automatically Collected Information</h3>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Log Data:</strong> App crashes, error reports, and performance metrics</li>
                    <li style={{ marginBottom: '8px' }}><strong>Cookies and Similar Technologies:</strong> Session data and app preferences</li>
                    <li style={{ marginBottom: '8px' }}><strong>Location Data:</strong> Approximate location based on IP address (if applicable)</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>2. How We Use Your Information</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>We use the collected information for the following purposes:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Educational Services:</strong> Provide personalized learning content, track progress, and deliver educational materials</li>
                    <li style={{ marginBottom: '8px' }}><strong>Account Management:</strong> Create and manage user accounts, authenticate users, and maintain account security</li>
                    <li style={{ marginBottom: '8px' }}><strong>Communication:</strong> Send notifications, updates, and important announcements related to your education</li>
                    <li style={{ marginBottom: '8px' }}><strong>App Improvement:</strong> Analyze usage patterns to improve app functionality and user experience</li>
                    <li style={{ marginBottom: '8px' }}><strong>Technical Support:</strong> Provide customer support and resolve technical issues</li>
                    <li style={{ marginBottom: '8px' }}><strong>Security:</strong> Protect against fraud, unauthorized access, and other security threats</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>3. Information Sharing and Disclosure</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>

                <h3 style={{
                    color: '#2c3e50',
                    marginTop: '20px',
                    marginBottom: '10px'
                }}>3.1 Service Providers</h3>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Firebase Services:</strong> We use Google Firebase for authentication, cloud storage, and messaging services</li>
                    <li style={{ marginBottom: '8px' }}><strong>Cloud Storage:</strong> Educational content and user data are stored securely using Firebase and AWS services</li>
                    <li style={{ marginBottom: '8px' }}><strong>Analytics:</strong> Usage analytics to improve app performance and user experience</li>
                </ul>

                <h3 style={{
                    color: '#2c3e50',
                    marginTop: '20px',
                    marginBottom: '10px'
                }}>3.2 Legal Requirements</h3>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}>When required by law or legal process</li>
                    <li style={{ marginBottom: '8px' }}>To protect our rights, property, or safety</li>
                    <li style={{ marginBottom: '8px' }}>To protect the rights, property, or safety of our users</li>
                    <li style={{ marginBottom: '8px' }}>In connection with a business transaction (merger, acquisition, etc.)</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>4. Data Security</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>We implement appropriate technical and organizational measures to protect your personal information:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Encryption:</strong> Data is encrypted in transit and at rest</li>
                    <li style={{ marginBottom: '8px' }}><strong>Secure Storage:</strong> User data is stored on secure cloud servers with industry-standard security measures</li>
                    <li style={{ marginBottom: '8px' }}><strong>Access Controls:</strong> Limited access to personal information on a need-to-know basis</li>
                    <li style={{ marginBottom: '8px' }}><strong>Regular Updates:</strong> Security measures are regularly reviewed and updated</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>5. Third-Party Services</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>Our app integrates with the following third-party services:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Google Sign-In:</strong> For user authentication (subject to Google&apos;s Privacy Policy)</li>
                    <li style={{ marginBottom: '8px' }}><strong>Firebase (Google):</strong> For cloud storage, messaging, and analytics (subject to Google&apos;s Privacy Policy)</li>
                    <li style={{ marginBottom: '8px' }}><strong>AWS S3:</strong> For media storage and content delivery</li>
                    <li style={{ marginBottom: '8px' }}><strong>Flutter Framework:</strong> For app functionality and cross-platform compatibility</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>6. Permissions and Device Access</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>Our app requests the following permissions:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Camera Access:</strong> To capture photos and videos for educational content</li>
                    <li style={{ marginBottom: '8px' }}><strong>Storage Access:</strong> To download and store educational materials offline</li>
                    <li style={{ marginBottom: '8px' }}><strong>Internet Access:</strong> To sync data and download content</li>
                    <li style={{ marginBottom: '8px' }}><strong>Notification Access:</strong> To send study reminders and important updates</li>
                    <li style={{ marginBottom: '8px' }}><strong>Network State:</strong> To check connectivity and optimize data usage</li>
                    <li style={{ marginBottom: '8px' }}><strong>Wake Lock:</strong> To ensure uninterrupted learning sessions</li>
                    <li style={{ marginBottom: '8px' }}><strong>Alarm Access:</strong> To schedule study reminders and notifications</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>7. Data Retention</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>We retain your personal information for as long as necessary to:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}>Provide educational services and maintain your account</li>
                    <li style={{ marginBottom: '8px' }}>Comply with legal obligations</li>
                    <li style={{ marginBottom: '8px' }}>Resolve disputes and enforce our agreements</li>
                </ul>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>When you delete your account, we will delete your personal information within 30 days, except where retention is required by law.</p>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>8. Your Rights and Choices</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>You have the following rights regarding your personal information:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Access:</strong> Request access to your personal information</li>
                    <li style={{ marginBottom: '8px' }}><strong>Correction:</strong> Request correction of inaccurate information</li>
                    <li style={{ marginBottom: '8px' }}><strong>Deletion:</strong> Request deletion of your personal information</li>
                    <li style={{ marginBottom: '8px' }}><strong>Portability:</strong> Request a copy of your data in a portable format</li>
                    <li style={{ marginBottom: '8px' }}><strong>Opt-out:</strong> Opt out of certain communications and data processing</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>9. Children&apos;s Privacy</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>Our app is designed for educational purposes and may be used by children under parental supervision. We do not knowingly collect personal information from children under 13 without parental consent. If you believe we have collected information from a child under 13, please contact us immediately.</p>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>10. International Data Transfers</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your information during such transfers.</p>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>11. Changes to This Privacy Policy</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>We may update this Privacy Policy from time to time. We will notify you of any changes by:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}>Posting the new Privacy Policy in the app</li>
                    <li style={{ marginBottom: '8px' }}>Sending you a notification through the app</li>
                    <li style={{ marginBottom: '8px' }}>Updating the &quot;Last Updated&quot; date at the bottom of this policy</li>
                </ul>

                <h2 style={{
                    color: '#34495e',
                    marginTop: '30px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #3498db',
                    paddingLeft: '15px'
                }}>12. Compliance</h2>

                <p style={{ marginBottom: '15px', textAlign: 'justify' }}>This Privacy Policy is designed to comply with:</p>
                <ul style={{ marginBottom: '15px' }}>
                    <li style={{ marginBottom: '8px' }}>General Data Protection Regulation (GDPR)</li>
                    <li style={{ marginBottom: '8px' }}>Children&apos;s Online Privacy Protection Act (COPPA)</li>
                    <li style={{ marginBottom: '8px' }}>California Consumer Privacy Act (CCPA)</li>
                    <li style={{ marginBottom: '8px' }}>Other applicable data protection laws</li>
                </ul>

                <div style={{
                    backgroundColor: '#e8f4f8',
                    border: '1px solid #bee5eb',
                    padding: '20px',
                    borderRadius: '5px',
                    marginTop: '30px'
                }}>
                    <h2 style={{
                        color: '#34495e',
                        marginTop: '30px',
                        marginBottom: '15px',
                        borderLeft: '4px solid #3498db',
                        paddingLeft: '15px'
                    }}>13. Contact Information</h2>
                    <p style={{ marginBottom: '15px', textAlign: 'justify' }}>If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
                    <ul style={{ marginBottom: '15px' }}>
                        <li style={{ marginBottom: '8px' }}><strong>Email:</strong> privacy@welearn4u.com</li>
                        <li style={{ marginBottom: '8px' }}><strong>Website:</strong> https://welearn4u.com</li>
                        <li style={{ marginBottom: '8px' }}><strong>Support:</strong> support@welearn4u.com</li>
                        <li style={{ marginBottom: '8px' }}><strong>API Base URL:</strong> https://api.welearn4u.com</li>
                    </ul>
                    <p style={{ marginBottom: '15px', textAlign: 'justify' }}>We will respond to your inquiry within 30 days of receipt.</p>
                </div>

                <div style={{
                    textAlign: 'center',
                    fontStyle: 'italic',
                    color: '#666',
                    marginTop: '30px',
                    paddingTop: '20px',
                    borderTop: '1px solid #ddd'
                }}>
                    <p style={{ marginBottom: '15px', textAlign: 'justify' }}><strong>Last Updated:</strong> October 13, 2024</p>
                    <p style={{ marginBottom: '15px', textAlign: 'justify' }}>This Privacy Policy is effective as of the date of last update.</p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
